import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import headerLogo from "../assets/headerLogo.png";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionCreators, persistor } from "../store";
import googleTagFire from "../utills/googleTagFire";
import { setToken } from "../store/api/config/AxiosConfig";
import { signOut } from "firebase/auth";
import { showMessege } from "./CustomMessage";
import { auth } from "../utills/firebase-config";
import { FaCircle } from "react-icons/fa";
import { Button, Popover } from "antd";
import { CloseOutlined, MenuOutlined } from "@ant-design/icons";
import { SettingsApi } from "../store/api";

function Header() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const therapyReducer = useSelector((state) => state.TherapyReducer);
  const authStore = useSelector((state) => state.AuthReducer); //store data
  const myJourneyGraph = useSelector((state) => state.MbcReducer);
  const { logOutAction } = bindActionCreators(ActionCreators, dispatch); //call action
  const loginStatus = authStore.loginStatus;
  const [disableTherapyBtn, setDisableTherapyBtn] = useState(false);
  const [disableMyJourneyBtn, setDisableMyJourneyBtn] = useState(false);
  const [hasInstructorHistory, setHasInstructorHistory] = useState(false);

  const [open, setOpen] = useState(false);
  const hide = () => {
    setOpen(false);
  };
  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };

  useEffect(() => {
    if (!myJourneyGraph?.myJourneyGraph?.status) {
      setDisableMyJourneyBtn(true);
    } else {
      setDisableMyJourneyBtn(false);
    }
  }, [myJourneyGraph]);

  useEffect(() => {
    if (loginStatus) {
      // Called here (not just inside TherapyTab) because a fresh account with
      // no patient_profile.instructor/appointment yet never mounts TherapyTab,
      // so its internal user_instructors call would never fire otherwise —
      // leaving the nav link permanently hidden for that account.
      SettingsApi.getUserInstructors()
        .then((res) => {
          setHasInstructorHistory(res?.data?.results?.length > 0);
        })
        .catch(() => {
          setHasInstructorHistory(false);
        });
    } else {
      setHasInstructorHistory(false);
    }
  }, [loginStatus]);

  useEffect(() => {
    if (therapyReducer) {
      if (
        !therapyReducer?.result?.patient_profile?.instructor &&
        !therapyReducer?.result?.appointment &&
        !hasInstructorHistory
      ) {
        setDisableTherapyBtn(true);
      } else {
        setDisableTherapyBtn(false);
      }
    }
  }, [therapyReducer, hasInstructorHistory]);

  const authHandle = () => {
    if (loginStatus) {
      googleTagFire("Sign Out");
      setToken(null);
      signOut(auth)
        .then(() => {
          navigate("/");
          persistor.purge();
          logOutAction();
        })
        .catch(() => {
          showMessege("error", "Logout Unsuccessful");
        });
    } else {
      navigate("/sign-up");
    }
  };

  const items = [
    {
      label: (
        <Link
          to="/therapy"
          className="font-montserrat tw-text-base tw-text-black hover:tw-text-primary"
        >
          Therapy
        </Link>
      ),
      key: "therapy",
    },
    {
      label: (
        <Link
          to="/my-journey"
          className="font-montserrat tw-text-base tw-text-black hover:tw-text-primary"
        >
          My Journey
        </Link>
      ),
      key: "my_journey",
    },
    // {
    //   label: (
    //     <Link
    //       to="https://go.onelink.me/5wa8/2a695a90"
    //       className="font-montserrat tw-text-base tw-text-black hover:tw-text-primary"
    //       target="_blank"
    //     >
    //       Download The App
    //     </Link>
    //   ),
    //   key: "download",
    // },

    {
      label: (
        <>
          <Link
            to="/settings"
            className="font-montserrat tw-text-base tw-text-black hover:tw-text-primary tw-relative"
          >
            Settings
            {therapyReducer?.result?.user_consent_form?.length > 0 && (
              <FaCircle className="tw-text-[#FD2222] tw-absolute -tw-top-1 -tw-right-3 tw-h-2.5 tw-w-2.5" />
            )}
          </Link>
        </>
      ),
      key: "settings",
    },

    {
      label: (
        <div className="tw-flex tw-flex-col tw-items-center md:tw-gap-4 md:tw-flex-row">
          {!loginStatus && (
            <Link
              to="/sign-in"
              className="font-montserrat tw-text-sm tw-font-medium tw-text-black hover:tw-text-primary"
            >
              Log In
            </Link>
          )}
          <Button
            type="primary"
            size="large"
            className="font-montserrat tw-text-sm tw-font-medium tw-h-9 md:tw-min-w-[100px] tw-min-w-full tw-mt-4 md:tw-mt-0"
            shape="round"
            onClick={authHandle}
          >
            {loginStatus ? "Sign Out" : "Sign Up"}
          </Button>
        </div>
      ),
      key: "sign_in_or_out",
    },
  ].filter((item) => {
    if (!loginStatus) {
      return item.key === "sign_in_or_out" || item.key === "download";
    } else {
      if (disableTherapyBtn && item.key === "therapy") {
        return false;
      }

      return !(item.key === "my_journey" && disableMyJourneyBtn);

      // if (item.key === "my_journey" && disableMyJourneyBtn) {
      //   return false;
      // }
    }
  });

  return (
    <header className="tw-w-full tw-mx-auto lg:tw-px-6 tw-px-4 lg:tw-h-[65px] tw-h-[56px] tw-flex tw-items-center tw-justify-between tw-sticky tw-top-0 tw-z-50 tw-bg-white tw-border-x-0 tw-border-t-0 tw-border-b tw-border-solid tw-border-[#80808017]">
      <Link to="/">
        <img
          src={headerLogo}
          className="tw-h-6 md:tw-h-7 lg:tw-h-8"
          alt="logo"
        />
      </Link>
      <div className="md:tw-flex md:tw-gap-6 lg:tw-gap-8 tw-items-center tw-hidden">
        {items?.map((item) => (
          <React.Fragment key={item.key}>{item.label}</React.Fragment>
        ))}
      </div>
      <div className="md:tw-hidden">
        <Popover
          trigger="click"
          placement="bottomRight"
          open={open}
          onOpenChange={handleOpenChange}
          content={
            <div className="tw-flex tw-flex-col tw-gap-3 tw-p-2">
              {items?.map((item) => (
                <div key={item.key} className="tw-w-full" onClick={hide}>
                  {item.label}
                </div>
              ))}
            </div>
          }
        >
          <div className="tw-relative">
            <Button
              type="primary"
              shape="default"
              icon={open ? <CloseOutlined /> : <MenuOutlined />}
            />
            {therapyReducer?.result?.user_consent_form?.length > 0 && (
              <FaCircle className="tw-text-[#FD2222] tw-absolute -tw-top-1 -tw-right-1 tw-h-2.5 tw-w-2.5" />
            )}
          </div>
        </Popover>
      </div>
    </header>
  );
}

export default Header;
